import config from '../config';
import { request } from '../utils/request';

const roleDomain = `${config.host}${config.apiRouter.role}`;

const api = {
  // GetAllRole
  get_all_role (data) {
    return request.post(`${roleDomain}/GetAllRole`, data || {});
  },

  // UpdateRole
  update_role (data) {
    return request.post(`${roleDomain}/UpdateRole`, data || {});
  },

  // UpdateRoleIdByUid
  update_role_id_by_uid (data) {
    return request.post(`${roleDomain}/UpdateRoleIdByUid`, data || {});
  },

  // GetAccountRole
  get_account_role (data) {
    return request.post(`${roleDomain}/GetAccountRole`, data || {});
  },

  // GetRoleByUid
  get_role_by_uid (data) {
    return request.post(`${roleDomain}/GetRoleByUid`, data || {});
  },

  // GetRoleByUidAllPermit
  get_role_by_uid_all_permit () {
    return request.post(`${roleDomain}/GetRoleByUidAllPermit`, {});
  },
};
export default api;
